import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { initializeChartLanguage, invalidateChartLanguage } from '../utils/languagePreference';
import config from '../config';

// Lives above routes: internal chart navigation and focus never reread profile.
export default function LanguageInitialization({ auth, isAuthenticated }) {
  const entrySearch = useRef(window.location.search);
  const identity = config.app.shareMode ? 'public' : (isAuthenticated && auth && auth.id);
  useEffect(() => {
    if (!identity) return undefined;
    initializeChartLanguage(auth, entrySearch.current);
    return invalidateChartLanguage;
    // The entry URL/auth snapshot belongs to this identity, not route rerenders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identity]);
  return null;
}

LanguageInitialization.propTypes = {
  auth: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  isAuthenticated: PropTypes.bool,
};
LanguageInitialization.defaultProps = { auth: null, isAuthenticated: false };
